<template>
    <q-modal v-model="modalKit" no-backdrop-dismiss no-esc-dismiss>
        <div>
            <v-header
                    :title="$T('lending kit') + ' ' + (form.id || '') + ' - ' + (form['stock_status.description'] ?
                     $T(form['stock_status.description'].toLowerCase()) : '')"
                    icon="find in page">
                <template slot="right">
                    <v-button flat rounded dense color="primary"
                              icon="close"
                              :label="$T('close')"
                              :disable="form.busy || isLoading"
                              @click="close"/>
                </template>
            </v-header>
            <card width="100%">

                <form v-if="user"
                      class="row gutter-xs"
                      @keydown="form.onKeydown($event)">

                    <v-display v-model="form['lending_point.description']"
                               :label="$t('lending point')"
                               :form="form"
                               class="col-md-6 col-xs-12">
                    </v-display>

                    <v-display v-model="form.identifier"
                               :label="$t('identifier')"
                               :form="form"
                               class="col-md-6 col-xs-12">
                    </v-display>

                    <v-display v-model="form.codentify"
                               :label="$t('codentify')"
                               :form="form"
                               class="col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                    <v-display v-model="form['lending_kit_color.lending_kit_model.description']"
                            :label="$t('model')"
                            :form="form"
                            class="col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                    <v-display v-model="form['lending_kit_color.sku']"
                            :label="$t('sku code')"
                            :form="form"
                            class="col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                    <v-display v-model="form['lending_kit_color.description']"
                            :label="$t('sku description')"
                            :form="form"
                            class="col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                    <v-display v-if="form['lending_kit_color.image']" class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                        <img height="46" :src="`/storage/uploads/${form['lending_kit_color.image']}`">                        
                    </v-display>

                    <v-display v-model="form.child_codentify_1"
                               :label="$t('child codentify 1')"
                               :form="form"
                               class="col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                    <v-display v-model="form.child_codentify_2"
                               :label="$t('child codentify 2')"
                               :form="form"
                               class="col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                    <v-radio-buttons v-if="actions.length > 1"
                                     path="action"
                                     v-model="action"
                                     :label="$t('actions')"
                                     :options="actions"
                                     :form="form"
                                     @input="makeActionDataAdjustments"
                                     class="col-12">
                    </v-radio-buttons>

                    <!-- Submit Button -->
                    <div class="col-12 row justify-center q-mt-md group">

                        <v-button v-if="(!['In Lending', 'Reserved'].includes(form['stock_status.description']) &&
                                    'Courier' == user.role.name) ||
                                    (!['In Lending'].includes(form['stock_status.description']) &&
                                    ('Admin' == user.role.name || 'Backoffice' === user.role.name))"
                                  outline
                                  :label="$T('move lending kit')"
                                  icon="save"
                                  color="highlight"
                                  class="no-shadow uppercase q-btn-iqos"
                                  @click.native="moveTo(actions.find(a => a.value == action).stockStatus)"
                                  :loading="form.busy">
                            <template slot="loading">
                                <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                                {{ $T('saving...') | capitalize }}
                            </template>
                        </v-button>


                        <v-button v-if="isLendingCircular" outline
                                :label="$T('disable Lending Circular')"
                                icon="save"
                                color="highlight"
                                class="no-shadow uppercase q-btn-iqos"
                                @click.native="disableLendingCircular"
                                :loading="form.busy">
                          <template slot="loading">
                            <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                            {{ $T('saving...') | capitalize }}
                          </template>
                        </v-button>

                    </div>

                </form>

                <div class="justify-center row layout-padding" v-else>
                    <spinner-iqos size="60px"/>
                </div>

            </card>
        </div>
    </q-modal>
</template>

<script>
    import Form from 'vform'
    import {mapGetters} from 'vuex'
    import lendingKitModel from './lendingKitModel'
    import {
        QSpinnerPuff,
        QModal
    } from 'quasar-framework'
    import changeCase from 'change-case'
    import VInput from "../components/form/VInput.vue";
    import VSelect from "../components/form/VSelect.vue";

    export default {
        mixins: [lendingKitModel],

        components: {
          VSelect,
          VInput,
            QSpinnerPuff,
            QModal
        },

        props: {
            show: Boolean,
            item: {
                type: Object,
                default: {}
            }
        },

        data() {
            return {
                modalKit: this.show,
                form: {},
                isLoading: false,
                action: 0,
                booleanOptions: [
                  {value: 'Yes', label: this.$T('Yes')},
                  {value: 'No', label: this.$T('No')}
                ]
            }
        },

        watch: {
            show(newVal) {
                this.modalKit = newVal
            },

            item(newVal) {
                Object.keys(this.lendingKitModel).forEach((i) => this.lendingKitModel[i] = null);
                this.form = new Form(Object.assign(this.lendingKitModel, newVal))
            }
        },

        methods: {
            close() {
                this.modalKit = false
                this.action = 0
                this.$emit('close')
            },

            moveTo(stockStatus) {
                this.form.post(`${this.baseUrl}/lending-kit/${this.form.id}/move-to/${stockStatus}`, {
                    status
                })
                    .then(({data}) => {
                        this.close()
                        this.$emit('updated')
                        this.$q.dialog({
                            title: this.$T('success'),
                            message: data.success.message,
                            preventClose: true,
                            color: 'primary',
                            stackButtons: true,
                            ok: {
                                label: this.$T('close'),
                            }
                        })
                    })
                    .catch(() => {
                    })
            },

            disableLendingCircular() {
              this.$q.dialog({
                title: 'Confirmar',
                message: 'Tem a certeza de que quer desativar o empréstimo circular para este kit?',
                ok: 'Sim',
                cancel: 'Não'
              }).then(() => {
                this.form.post(`${window.config.appUrl}/api/v1/lending-point/lending-kit/${this.form.id}/disable-lending-circular`)
                    .then(({data}) => {
                      this.$emit('updated')
                      this.$q.dialog({
                        title: this.$T('success'),
                        message: data.success.message,
                        preventClose: true,
                        color: 'primary',
                        stackButtons: true,
                        ok: {
                          label: this.$T('close'),
                        }
                      }).then(() => {
                        this.close()
                      })
                    })
              })
            },
        },

        computed: {
            ... mapGetters({
                user: 'auth/user'
            }),

            baseUrl() {
                return `${window.config.appUrl}/api/v1/${changeCase.paramCase(this.user.role.name)}`
            },

            actions() {
                let role = this.user.role.name
                let stockStatus = this.form['stock_status.description']

                let actions = [{value: 0, label: this.$T('no action')}]

                actions = [];
                if ((!['In Lending'].includes(stockStatus) && (role === 'Admin' || role === 'Backoffice'))) {
                    actions = [
                        {value: 0, stockStatus: 'available', label: `> ${this.$T('available')}`},
                        {value: 22, stockStatus: 'broken', label: `> ${this.$T('broken')}`},
                        {value: 23, stockStatus: 'lost', label: `> ${this.$T('lost')}`}
                    ]
                } else if ((!['In Lending', 'Reserved'].includes(stockStatus) && role === 'Courier')) {
                    actions = [
                        {value: 0, stockStatus: 'available', label: `> ${this.$T('available')}`},
                        {value: 22, stockStatus: 'broken', label: `> ${this.$T('broken')}`},
                    ]
                }
                return actions
            },

            isLendingCircular () {
               return this.form.is_circular_lending === 'Yes' && this.user.lending_point.is_circular_lending
            },
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/_lendingKitDetail.vue